import { useEffect, useState } from "react";
import { getCatalogItem, getCatalogItems } from "@/api/catalog";
// import { useEditorActions } from "@/Apps/Pages/Editor/EditorCanvas";
import SectionWrapper from "../SectionWrapper";
import DropdownGroup from "../../groups/DropdownGroup";
import { getPage } from "@/api/pages";
import { getSessionToken } from "@/api/auth";
import { get } from "lodash";
import { client } from "@/client";
import { GET_PAGE } from "@/api/gql/pages";
import Section from "../../../Section";
import Button from "@/ui/Button";
import { ColorPicker } from "../../..";
import { DownCarrotIcon } from "@/ui/Icons";
// import { DEFAULT_PAGE_ID } from "@/Apps/Pages/Editor/types";
import {
  argbFromHex,
  rgbaFromArgb,
  themeFromSourceColor,
  applyTheme,
} from "@material/material-color-utilities";

export const defaultColorPalettes = [
  {
    id: "monochrome-black-gray",
    label: "Monochrome Black & Gray",
    values: {
      primary: "#141414", onPrimary: "#FFFFFF",
      secondary: "#4B5562", onSecondary: "#FFFFFF",
      inverseSurface: "#141414", onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#202A37", onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#4B5562", onSurfaceContainer: "#141414",
      surfaceContainerLow: "#F9FAFB", onSurfaceContainerLow: "#141414",
      surface: "#FFFFFF", onSurface: "#141414",
    },
  },
  {
    id: "classic-blue-gray",
    label: "Classic Blue & Gray",
    values: {
      primary: "#1E3A8A", onPrimary: "#FFFFFF",
      secondary: "#60A5FA", onSecondary: "#141414",
      inverseSurface: "#1E3A8A", onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#2A4375", onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#475569", onSurfaceContainer: "#FFFFFF",
      surfaceContainerLow: "#F1F5F9", onSurfaceContainerLow: "#1E3A8A",
      surface: "#FFFFFF", onSurface: "#1E3A8A",
    },
  },
  // {
  //   id: "modern-teal-charcoal",
  //   label: "Modern Teal & Charcoal",
  //   values: {
  //     primary: "#00897B",
  //     secondary: "#37474F",
  //     accent: "#FF7043",
  //     background: "#ECEFF1",
  //     text: "#000000",
  //   },
  // },
  // {
  //   id: "elegant-black-gold",
  //   label: "Elegant Black & Gold",
  //   values: {
  //     primary: "#222831",
  //     secondary: "#393E46",
  //     accent: "#FFD369",
  //     background: "#EEEEEE",
  //     text: "#000000",
  //   },
  // },
  // {
  //   id: "bold-red-dark-gray",
  //   label: "Bold Red & Dark Gray",
  //   values: {
  //     primary: "#D72638",
  //     secondary: "#373F51",
  //     accent: "#F8E16C",
  //     background: "#F4F4F9",
  //     text: "#000000",
  //   },
  // },
  {
    id: "navy-soft-green",
    label: "Navy & Soft Green",
    values: {
      primary: "#2C3E50", onPrimary: "#FFFFFF",
      inverseSurface: "#2C3E50", onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#37474F", onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#4CAF50", onSurfaceContainer: "#2C3E50",
      surfaceContainerLow: "#ECF0F1", onSurfaceContainerLow: "#2C3E50",
      surface: "#FFFFFF", onSurface: "#2C3E50",
      secondary: "#4CAF50", onSecondary: "#141414",
    },
  },
  {
    id: "sophisticated-purple-gray",
    label: "Sophisticated Purple & Gray",
    values: {
      primary: "#6A0572",
      inverseSurface: "#6A0572", onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#7C1A52", onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#8A8D93", onSurfaceContainer: "#6A0572",
      surfaceContainerLow: "#F7F9FC", onSurfaceContainerLow: "#6A0572",
      surface: "#FFFFFF", onSurface: "#6A0572",
      secondary: "#8A8D93", onSecondary: "#141414",
    },
  },
  {
    id: "earthy-olive-cream",
    label: "Earthy Olive & Cream",
    values: {
      primary: "#556B2F", onPrimary: "#FFFFFF",
      inverseSurface: "#556B2F", onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#63793F", onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#8F9779", onSurfaceContainer: "#556B2F",
      surfaceContainerLow: "#FAF3E0", onSurfaceContainerLow: "#556B2F",
      surface: "#FFFFFF", onSurface: "#556B2F",
      secondary: "#8F9779", onSecondary: "#141414",
    },
  },
  {
    id: "minimalist-white-dark-blue",
    label: "Minimalist White & Dark Blue",
    values: {
      primary: "#1B263B",            // deep blue
      onPrimary: "#FFFFFF",
      secondary: "#415A77",          // muted blue
      onSecondary: "#FFFFFF",
      inverseSurface: "#1B263B",     // match primary for dark inverse
      onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#273A56", // slightly lighter blue
      onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#778DA9",   // soft blue-gray
      onSurfaceContainer: "#1B263B",
      surfaceContainerLow: "#E0E1DD", // off-white background
      onSurfaceContainerLow: "#1B263B",
      surface: "#FFFFFF",            // white
      onSurface: "#1B263B",
      accent: "#FF8C42",             // orange accent
      background: "#E0E1DD",         // off-white
      text: "#1B263B",               // deep blue for text
    },
  },
  {
    id: "warm-beige-navy",
    label: "Warm Beige & Navy",
    values: {
      primary: "#22333B", // navy
      onPrimary: "#FFFFFF",
      secondary: "#B8B8AA", // warm beige
      onSecondary: "#22333B",
      inverseSurface: "#22333B",
      onInverseSurface: "#FFFFFF",
      surfaceContainerHigh: "#2D3A4A",
      onSurfaceContainerHigh: "#FFFFFF",
      surfaceContainer: "#B8B8AA",
      onSurfaceContainer: "#22333B",
      surfaceContainerLow: "#F5F3F4",
      onSurfaceContainerLow: "#22333B",
      surface: "#FFFFFF",
      onSurface: "#22333B",
      accent: "#D17A22", // orange accent
      background: "#F5F3F4",
      text: "#22333B",
    },
  },
  // {
  //   id: "futuristic-cyan-black",
  //   label: "Futuristic Cyan & Black",
  //   values: {
  //     primary: "#00ADB5", // cyan
  //     onPrimary: "#FFFFFF",
  //     secondary: "#393E46", // dark gray
  //     onSecondary: "#00ADB5",
  //     inverseSurface: "#222831",
  //     onInverseSurface: "#00ADB5",
  //     surfaceContainerHigh: "#393E46",
  //     onSurfaceContainerHigh: "#00ADB5",
  //     surfaceContainer: "#393E46",
  //     onSurfaceContainer: "#00ADB5",
  //     surfaceContainerLow: "#222831",
  //     onSurfaceContainerLow: "#00ADB5",
  //     surface: "#222831", // black
  //     onSurface: "#00ADB5",
  //     accent: "#FF2E63", // magenta accent
  //     background: "#222831",
  //     text: "#FFFFFF",
  //   },
  // },
  // {
  //   id: "midnight-blue-bronze",
  //   label: "Midnight Blue & Bronze",
  //   values: {
  //     primary: "#102A43", // midnight blue
  //     onPrimary: "#FFD700",
  //     secondary: "#855E42", // bronze
  //     onSecondary: "#102A43",
  //     inverseSurface: "#191919",
  //     onInverseSurface: "#FFD700",
  //     surfaceContainerHigh: "#1B3A5B",
  //     onSurfaceContainerHigh: "#FFD700",
  //     surfaceContainer: "#855E42",
  //     onSurfaceContainer: "#102A43",
  //     surfaceContainerLow: "#191919",
  //     onSurfaceContainerLow: "#FFD700",
  //     surface: "#191919",
  //     onSurface: "#FFD700",
  //     accent: "#FFD700", // gold
  //     background: "#191919",
  //     text: "#FFD700",
  //   },
  // },
  {
    id: "espresso-burgundy",
    label: "Espresso & Burgundy",
    values: {
      primary: "#4B2C20", // espresso
      onPrimary: "#E1B07E",
      secondary: "#800020", // burgundy
      onSecondary: "#E1B07E",
      inverseSurface: "#1F120D",
      onInverseSurface: "#E1B07E",
      surfaceContainerHigh: "#3A2117",
      onSurfaceContainerHigh: "#E1B07E",
      surfaceContainer: "#800020",
      onSurfaceContainer: "#E1B07E",
      surfaceContainerLow: "#1F120D",
      onSurfaceContainerLow: "#E1B07E",
      surface: "#1F120D",
      onSurface: "#E1B07E",
      accent: "#E1B07E", // tan accent
      background: "#1F120D",
      text: "#E1B07E",
    },
  },
  // {
  //   id: "soft-lavender-peach",
  //   label: "Soft Lavender & Peach",
  //   values: {
  //     primary: "#B565A7", // lavender
  //     onPrimary: "#FFF5E1",
  //     secondary: "#F7C5A8", // peach
  //     onSecondary: "#6D597A",
  //     inverseSurface: "#6D597A",
  //     onInverseSurface: "#FFF5E1",
  //     surfaceContainerHigh: "#D6A4DD",
  //     onSurfaceContainerHigh: "#6D597A",
  //     surfaceContainer: "#F7C5A8",
  //     onSurfaceContainer: "#6D597A",
  //     surfaceContainerLow: "#FFF5E1",
  //     onSurfaceContainerLow: "#6D597A",
  //     surface: "#FFF5E1",
  //     onSurface: "#6D597A",
  //     accent: "#6D597A", // muted purple
  //     background: "#FFF5E1",
  //     text: "#6D597A",
  //   },
  // },
  {
    id: "mint-sky-blue",
    label: "Mint & Sky Blue",
    values: {
      primary: "#A8E6CF", // mint
      onPrimary: "#074F57",
      secondary: "#74B3CE", // sky blue (matches blue)
      onSecondary: "#074F57",
      inverseSurface: "#74B3CE", // sky blue
      onInverseSurface: "#074F57",
      surfaceContainerHigh: "#74B3CE",
      onSurfaceContainerHigh: "#074F57",
      surfaceContainer: "#A8E6CF", // mint
      onSurfaceContainer: "#074F57",
      surfaceContainerLow: "#FFFFFF",
      onSurfaceContainerLow: "#074F57",
      surface: "#FFFFFF",
      onSurface: "#074F57",
      accent: "#74B3CE", // sky blue
      background: "#FFFFFF",
      text: "#074F57",
    },
  },
  {
    id: "custom",
    label: "Custom Theme",
    values: { },
  }
];

export const xdefaultColorPalettes = [
  {
    id: "monochrome-black-gray",
    label: "Monochrome Black & Gray",
    values: {
      primary: "#191919",
      secondary: "#333333",
      accent: "#666666",
      background: "#FFFFFF",
      text: "#000000",
    },
  },
  {
    id: "monochrome-white-gray",
    label: "Monochrome White & Gray",
    values: {
      primary: "#FFFFFF",
      secondary: "#CCCCCC",
      accent: "#999999",
      background: "#191919",
      text: "#FFFFFF",
    },
  },
  {
    id: "classic-blue-gray",
    label: "Classic Blue & Gray",
    values: {
      primary: "#1E3A8A",
      secondary: "#475569",
      accent: "#FACC15",
      background: "#F1F5F9",
      text: "#000000",
    },
  },
  {
    id: "modern-teal-charcoal",
    label: "Modern Teal & Charcoal",
    values: {
      primary: "#00897B",
      secondary: "#37474F",
      accent: "#FF7043",
      background: "#ECEFF1",
      text: "#000000",
    },
  },
  {
    id: "elegant-black-gold",
    label: "Elegant Black & Gold",
    values: {
      primary: "#222831",
      secondary: "#393E46",
      accent: "#FFD369",
      background: "#EEEEEE",
      text: "#000000",
    },
  },
  {
    id: "bold-red-dark-gray",
    label: "Bold Red & Dark Gray",
    values: {
      primary: "#D72638",
      secondary: "#373F51",
      accent: "#F8E16C",
      background: "#F4F4F9",
      text: "#000000",
    },
  },
  {
    id: "navy-soft-green",
    label: "Navy & Soft Green",
    values: {
      primary: "#2C3E50",
      secondary: "#4CAF50",
      accent: "#E67E22",
      background: "#ECF0F1",
      text: "#000000",
    },
  },
  {
    id: "sophisticated-purple-gray",
    label: "Sophisticated Purple & Gray",
    values: {
      primary: "#6A0572",
      secondary: "#8A8D93",
      accent: "#FF5E78",
      background: "#F7F9FC",
      text: "#000000",
    },
  },
  {
    id: "earthy-olive-cream",
    label: "Earthy Olive & Cream",
    values: {
      primary: "#556B2F",
      secondary: "#8F9779",
      accent: "#D2691E",
      background: "#FAF3E0",
      text: "#000000",
    },
  },
  {
    id: "minimalist-white-dark-blue",
    label: "Minimalist White & Dark Blue",
    values: {
      primary: "#1B263B",
      secondary: "#415A77",
      accent: "#FF8C42",
      background: "#E0E1DD",
      text: "#000000",
    },
  },
  {
    id: "warm-beige-navy",
    label: "Warm Beige & Navy",
    values: {
      primary: "#22333B",
      secondary: "#B8B8AA",
      accent: "#D17A22",
      background: "#F5F3F4",
      text: "#000000",
    },
  },
  {
    id: "futuristic-cyan-black",
    label: "Futuristic Cyan & Black",
    values: {
      primary: "#00ADB5",
      secondary: "#393E46",
      accent: "#FF2E63",
      background: "#222831",
      text: "#FFFFFF",
    },
  },
  {
    id: "midnight-blue-bronze",
    label: "Midnight Blue & Bronze",
    values: {
      primary: "#102A43",
      secondary: "#855E42",
      accent: "#FFD700",
      background: "#191919",
      text: "#FFFFFF",
    },
  },
  {
    id: "espresso-burgundy",
    label: "Espresso & Burgundy",
    values: {
      primary: "#4B2C20",
      secondary: "#800020",
      accent: "#E1B07E",
      background: "#1F120D",
      text: "#FFFFFF",
    },
  },
  {
    id: "soft-lavender-peach",
    label: "Soft Lavender & Peach",
    values: {
      primary: "#B565A7",
      secondary: "#F7C5A8",
      accent: "#6D597A",
      background: "#FFF5E1",
      text: "#000000",
    },
  },
  {
    id: "mint-sky-blue",
    label: "Mint & Sky Blue",
    values: {
      primary: "#A8E6CF",
      secondary: "#FFD3B6",
      accent: "#74B3CE",
      background: "#FFFFFF",
      text: "#000000",
    },
  },
  {
    id: "custom",
    label: "Custom Theme",
    values: { },
  }
];

export const ColorPaletteIcon = ({
  palette,
  className,
}: {
  palette: any;
  className?: string;
}) => {
  return (
    <div className={`flex mr-1`}>
      <div
        className={`w-3 h-3 mr-1 ${className}`}
        style={{ backgroundColor: palette.values.primary }}
      />
      <div
        className={`w-3 h-3 mr-1 ${className}`}
        style={{ backgroundColor: palette.values.secondary }}
      />
      <div
        className={`w-3 h-3 mr-1 ${className}`}
        style={{ backgroundColor: palette.values.inverseSurface }}
      />
      <div
        className={`w-3 h-3 mr-1 ${className}`}
        style={{ backgroundColor: palette.values.surface }}
      />
      {/* <div
        className={`w-3 h-3 mr-1 ${className}`}
        style={{ backgroundColor: palette.values.accent }}
      />
      <div
        className={`w-3 h-3 mr-1 ${className}`}
        style={{ backgroundColor: palette.values.background }}
      /> */}
    </div>
  );
};

export const Appearance = ({
  filter = {},
  type = "designs",
  isExpanded = true,
  colorPalettes = defaultColorPalettes,
  payload = {},
  onThemeChange = () => {},
  onColorChange = () => {},
}) => {
  const [templates, setTemplates] = useState([]);
  // const { updateContent } = useEditorActions();

  const fetchTemplates = async () => {
    const items = await getCatalogItems({ type, ...filter });
    console.log({ items });
    setTemplates(
      items.map(({ name, id, image }) => ({
        label: name,
        id,
        icon: (
          <div className="w-12 h-12 mr-2 overflow-hidden rounded">
            <img src={image} className="w-full" />
          </div>
        ),
      })) || []
    );
  };

  const handleTemplateChange = async (key) => {
    const template = templates[key];
    // console.log({ template })
    const id = template.id;

    // get the page content
    const templateData = await getCatalogItem(id);
    console.log({ template, templateData });

    // const { page } = templateData;
    // const { content } = page;
    // const token = getSessionToken();
    // const { content } = await getPage(templateData?.page?.id, { token })

    const pageDetails = await client.query({
      query: GET_PAGE,
      variables: { pageId: templateData?.page?.id },
    });
    const content = get(pageDetails, "data.page.content", false);

    // update the page with the content
    // if (updateContent) updateContent(content, DEFAULT_PAGE_ID);
    // console.log("Changing Content", content);
    onThemeChange(templateData?.id, content);
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const colorItems = colorPalettes.map((palette) => ({
    label: palette.label,
    id: palette.id,
    icon: <ColorPaletteIcon palette={palette} />,
  }));

  return (
    <SectionWrapper label="Appearance" isExpanded={isExpanded}>
      <div className="flex flex-col gap-2">
        {/* <DropdownGroup
          label="Theme"
          onChange={handleTemplateChange}
          value={payload?.find((v) => v.id === "themeId")?.value}
          items={templates}
        /> */}
        <DropdownGroup
          label="Colors"
          onChange={(key) => onColorChange(colorPalettes[key]?.id)}
          // value={payload?.find((v) => v.id === "colorPalette")?.value}
          value={payload?.find((v) => v.id === "palette")?.value}
          items={colorItems}
        />

        {/* <GenerateTheme onColorChange={onColorChange} /> */}
        {payload?.find((v) => v.id === "palette")?.value === "custom" && (
          <ColorPicker
            color={payload?.find((v) => v.id === "colors")?.value?.primary || "#000000"}
            text="Colors"
            onInstantChange={() => {}}
            onChange={(color) => {
              const theme = themeFromSourceColor(argbFromHex(color.hex));
              console.log({ theme });
              const colorValues = Object.fromEntries(
                Object.entries(theme?.schemes?.light?.props).map(([key, value]) => {
                  const { r, g, b, a } = rgbaFromArgb(value);
                  const alpha = (a / 255).toFixed(3).replace(/\.?0+$/, "");
                  return [key, `rgba(${r}, ${g}, ${b}, ${alpha})`];
                })
              );
              console.log({ colorValues });
              onColorChange("custom", colorValues);
            }}
          />        
        )}

      </div>
    </SectionWrapper>
  );
};